// UI texts: horde
export default {
  back: 'Back to the feed',
  tag: {
    live: 'Global event · Live',
    bossLive: 'Boss event · Live',
    scheduled: 'Global event · Tonight',
    bossScheduled: 'Boss event · Tonight',
    scheduledLater: 'Global event · Tomorrow',
    bossScheduledLater: 'Boss event · Tomorrow',
    victory: 'Victory',
    defeat: 'Defeat',
    /** 2. 10. 2026 (package 1, 10.b). */
    held: 'Held',
  },
  headline: {
    victory: 'The horde is broken',
    bossVictory: 'The boss is down',
    defeat: '{zone} has fallen',
    scheduled: 'A horde is closing in on {zone}',
    /** 10.b: too few survivors fought; the zone is not hurt. */
    held: 'The militia held the line',
  },
  endsIn: 'Ends in',
  startsIn: 'Starts in',
  health: 'Horde health',
  bossHealth: 'Boss health',
  left: '{p}% left',
  healthAria: '{p}% of the horde is down',
  tiers: { join: 'JOIN', p25: '25%', p50: '50%', p75: '75%', broken: 'BROKEN' },
  /** 1. 10. 2026 (C3): next to a personal threshold not reached yet. */
  yourDamage: 'yours {n}',
  totalDamage: 'Total damage',
  of: 'of {n}',
  notSized: 'not here yet',
  /** 10.b: before the start, the size as things stand. */
  forecast: '~{n} to break · militia about {pct}%',
  fighting: 'Survivors fighting',
  tide: 'Infected',
  crowd: {
    survivors: '{n} survivors',
    survivor: '1 survivor',
    militia: '{n} militia',
  },
  militiaJoined: '+ {n} militia · joined so far',
  militiaTookPart: '+ {n} militia · took part',
  joinedSoFar: 'joined so far',
  tookPart: 'took part',
  rewards: 'Rewards',
  state: { LOCKED: 'LOCKED', UNLOCKED: 'UNLOCKED', EARNED: 'EARNED', MISSED: 'MISSED', CLAIMED: 'CLAIMED' },
  needRank: 'NEED #{n}',
  missedRank: 'MISSED · #{n}',
  yourFight: 'Your fight',
  who: '{name} · LV {n}',
  contribution: 'Contribution',
  rank: 'Rank',
  topPct: 'top {p}%',
  waves: '{n} waves fought',
  wave: '1 wave fought',
  inWave: 'In the fight · wave returns in {t}',
  topFighters: 'Top fighters',
  militia: 'Militia',
  live: 'LIVE',
  final: 'FINAL',
  startsAt: 'Starts at {t}',
  you: '{name} (you)',
  notJoined: 'Not in the fight yet',
  noFighters: 'Nobody is on the line yet. Be the first.',
  join: 'Join the fight',
  inTheFight: 'In the fight',
  costAria: 'Costs {n} energy',
  joinSub: 'Sends {name} for one {m} min wave · you have {e} energy',
  inFightSub: '{name} is on the line. Wave returns in {t}.',
  noEnergy: 'Not enough energy · +1 in {t}',
  tooHurt: 'Too hurt to fight. Heal first.',
  /** Krug 5 (K16.2) */
  joinFromLv: 'Join from Lv {n}',
  joined: '{name} is on the line',
  /** Package 4, part O: the Horde Ration on joining. */
  rationEat: 'Eat a Horde Ration ({n} in Storage)',
  /** 10. 10. 2026 (owner, BACKLOG #41): the horde prepared as a run. */
  prep: {
    title: 'Prepare',
    feedSub: 'A wave takes about {n}. When the pack runs out, the wave takes from Storage. What is left comes back.',
    feedShort: 'Storage holds less than a wave takes: the last fights hit softer.',
    bandageSub: 'Used between fights below half health. What is left comes back.',
    guardFeedSub: 'For the waves you add: about {n}. Set aside now; your next run keeps its rounds. If it runs out, the waves take from Storage; what is left comes back after the horde.',
    guardSet: 'Set aside for the guard: {what}',
  },
  /** 8. 10. 2026 (owner): the waves take Ammo / Fuel from Storage; without it, a weapon that needs it deals less. */
  noFeed: 'No {what} in Storage: −{pct}% damage',
  feedLeft: 'Waves take {what} from Storage ({n} left)',
  rationEaten: 'Horde Ration eaten: on until the horde ends',
  claim: 'Claim rewards',
  shareStory: 'Share story',
  shareText: '{name} dealt {d} damage in the {zone} horde. Rank #{r}. Next horde tonight.',
  linkCopied: 'Link copied',
  next: 'Next horde {time} · {zone}',
  nextSub: 'Starts in {t}. Scout the zone while it is quiet.',
  tomorrow: 'tomorrow {t}',
  claimedTitle: 'Rewards received',
  claimedBody: 'Everything went to your camp storage.',
  openInventory: 'Open inventory',
  /** Package 4, part F (owner, 7. 10. 2026): the kind of tonight's horde, its strength, the boss's phases. */
  f: {
    strength: 'Strength {p}%',
    ifBroken: 'If it breaks',
    ifHolds: 'If it holds',
    phases: 'Boss phases',
    range: { p0: '100–66%', p1: '66–33%', p2: '33–0%' },
    chest: 'Shared chest: {p}% left',
    core: 'The core is open · {t}',
    healed: 'The Hive closed its core and healed',
    logAt: '{t} · {name}',
    guardWaves: '{n} of them on guard',
  },
  /** F4: Stand guard. 28. 10. 2026 (player report): the body says the energy of waves not fought comes back (`endHorde`). */
  guard: {
    title: 'Stand guard',
    body: 'Not online at {at}? From {from} prepay waves, 1 energy each, up to {n}. At {at} your survivor, with the gear and skills it has then, fights them one every {m} min. It uses none of your HP and blocks no run. Waves you play live deal 10% more, and a guard wave gives {x}% of their XP and {r}% of their finds and Season Score. Waves the horde does not last for give their energy back.',
    waves: 'On guard: {n} of {max} waves',
    add: '+1 wave',
    costAria: 'Costs {n} energy',
    // 13. 10. 2026 (owner): taking waves back, until an hour before the horde.
    remove: '−1 wave',
    removeAria: 'Take one wave back: its {n} energy comes back',
    removeUntil: 'You can take waves back until {t}: their energy and the rounds set aside come back.',
    removeLocked: 'Locked since {t}: the waves stay.',
    noEnergy: 'Not enough energy',
    fought: 'Your guard fought {n} of {max} waves: {d} damage.',
    notYet: 'Your guard fights {n} waves from {t}.',
  },
  empty: {
    title: 'The streets are quiet',
    body: 'Every evening at the same hour a horde enters one zone for 60 minutes. Everyone who joins adds damage, and rewards unlock at 25% and 50%. On Sundays it is a boss.',
    action: 'Back to camp',
  },
} as const;
